import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import MoreSvg from "../assets/svg/more.svg";
import useUserStore from "../store/userStore";
import { cn } from "../lib/utils";
import { Button } from "antd";

const Header = () => {
  const [isOnTop, setIsOnTop] = useState(true);
  const [showMenu, setShowMenu] = useState(false);
  const menuWrapRef = useRef(null);
  const location = useLocation();
  const { isLoggedIn, user, logout } = useUserStore();

  const logoUrl = require("../assets/img/Stabilize-Ai2.png");

  const handleScroll = () => {
    const scrollTop = window.scrollY;
    setIsOnTop(scrollTop === 0);
  };

  const handleClickOutside = (e) => {
    if (menuWrapRef.current && !menuWrapRef.current.contains(e.target)) {
      setShowMenu(false);
    }
  };

  // 路由切换后关闭菜单
  useEffect(() => {
    setShowMenu(false);
  }, [location.pathname]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    document.addEventListener("click", handleClickOutside);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleNavClick = () => {
    setShowMenu(false);
  };

  return (
    <header
      ref={menuWrapRef}
      className={`header-wrap fixed inset-x-0 top-0 z-30 duration-300 ease-in-out ${
        isOnTop
          ? "bg-[#ffffff00] text-white"
          : "bg-[#ffffffff] text-[#004b67] shadow-lg"
      }`}
    >
      <div className="container flex items-center justify-between py-2 md:py-0">
        <Link to="/" onClick={handleNavClick}>
          <img className="h-8" src={logoUrl} alt="Logo" />
        </Link>

        <div className="hidden md:flex">
          <Link
            className={cn(
              "px-4 py-6 text-sm",
              location.pathname === "/" && "font-bold"
            )}
            to="/"
            onClick={handleNavClick}
          >
            首页
          </Link>
          <Link
            className={cn(
              "px-4 py-6 text-sm",
              location.pathname === "/technology" && "font-bold"
            )}
            to="/technology"
            onClick={handleNavClick}
          >
            核心技术
          </Link>
          <Link
            className={cn(
              "px-4 py-6 text-sm",
              location.pathname === "/solutions" && "font-bold"
            )}
            to="/solutions"
            onClick={handleNavClick}
          >
            解决方案
          </Link>

          <Link
            className={cn(
              "px-4 py-6 text-sm",
              location.pathname === "/api-doc" && "font-bold"
            )}
            to="/api-doc"
            onClick={handleNavClick}
          >
            API文档
          </Link>

          <Link
            className={cn(
              "px-4 py-6 text-sm",
              location.pathname === "/about" && "font-bold"
            )}
            to="/about"
            onClick={handleNavClick}
          >
            关于我们
          </Link>

          {isLoggedIn ? (
            <div className="flex items-center gap-2 ml-4">
              <span className="px-4 py-6 text-sm">
                欢迎，{user?.name || user?.email}
              </span>
              <Button
                onClick={() => {
                  logout();
                  handleNavClick();
                }}
                type="primary"
              >
                退出登录
              </Button>
            </div>
          ) : (
            <div className="flex items-center gap-2 ml-4">
              <Link
                className="px-4 h-[32px] leading-[32px] text-sm border border-white rounded hover:bg-white hover:text-[#004b67]"
                to="/login"
                onClick={handleNavClick}
              >
                登录
              </Link>
            </div>
          )}
        </div>

        <div className="relative md:hidden">
          <img
            src={MoreSvg}
            className={cn(
              "icon-more w-[26px] h-[26px] cursor-pointer",
              isOnTop ? "invert" : ""
            )}
            onClick={() => setShowMenu(!showMenu)}
            alt="Menu"
          />
          {showMenu && (
            <div className="absolute right-0 w-28 rounded-sm bg-white text-center text-[#004b67] shadow-lg md:hidden">
              <Link
                className={cn(
                  "block px-4 py-2 text-sm",
                  location.pathname === "/" && "font-bold"
                )}
                to="/"
                onClick={handleNavClick}
              >
                首页
              </Link>
              <Link
                className={cn(
                  "block px-4 py-2 text-sm",
                  location.pathname === "/technology" && "font-bold"
                )}
                to="/technology"
                onClick={handleNavClick}
              >
                核心技术
              </Link>
              <Link
                className={cn(
                  "block px-4 py-2 text-sm",
                  location.pathname === "/solutions" && "font-bold"
                )}
                to="/solutions"
                onClick={handleNavClick}
              >
                解决方案
              </Link>
              <Link
                className={cn(
                  "block px-4 py-2 text-sm",
                  location.pathname === "/api-doc" && "font-bold"
                )}
                to="/api-doc"
                onClick={handleNavClick}
              >
                API文档
              </Link>
              {/* 注释掉的资讯链接，保持与Vue版本一致 */}
              {/* <Link className="block px-4 py-2 text-sm" to="/news" onClick={handleNavClick}>资讯</Link> */}
              <Link
                className={cn(
                  "block px-4 py-2 text-sm",
                  location.pathname === "/about" && "font-bold"
                )}
                to="/about"
                onClick={handleNavClick}
              >
                关于我们
              </Link>

              {isLoggedIn ? (
                <>
                  <div className="block px-4 py-2 text-sm text-gray-500 truncate">
                    欢迎，{user?.name || user?.email}
                  </div>
                  <button
                    className="block w-full text-center px-4 py-2 text-sm text-red-500 hover:bg-red-50"
                    onClick={() => {
                      logout();
                      handleNavClick();
                    }}
                  >
                    退出登录
                  </button>
                </>
              ) : (
                <Link
                  className="block px-4 py-2 text-sm"
                  to="/login"
                  onClick={handleNavClick}
                >
                  登录
                </Link>
              )}
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
